<!-- REVISION = 20220308204025 -->
<!-- https://www.javascripttutorial.net/dom/css/check-if-an-element-is-visible-in-the-viewport/ -->

<script>
	import { afterUpdate, onMount } from 'svelte';
    import { marked } from 'marked';

    export let slug = undefined;
    let category = {
        items: [],
    };
    $: window.history.pushState({slug: slug}, slug, `/${slug}`);
    $: update(slug);

    // const API = 'https://api-next.php8link.workers.dev';
    const API = 'https://api.php8.link';

    onMount(async () => {
        if (slug != undefined) {
            update();
        }
    });

    const update = async (slug) => {
        const url = `${API}/categories/${slug}`
        // console.log(url) //DEBUG
        const res = await fetch(url);
        category = await res.json();
        // console.dir(category); //DEBUG
        category.description = marked.parse(category.description)
    };

    afterUpdate(() => {
        document.getElementById('menu').style.setProperty('height', `${document.getElementById('category').offsetHeight}px`);
        const elementCategoryTitle = document.querySelector('#category h2');
        if (!isInViewport(elementCategoryTitle)) {
            elementCategoryTitle.scrollIntoView();
        }
    });

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

</script>

<svelte:head>
	<title>{category.title} | PHP8.link</title>
</svelte:head>

<div id="category">
    <h2>{category.title}</h2>
    <div>{@html category.description}</div>
    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Project</th>
                    <th>Description</th>
                    <th>URL</th>
                </tr>
            </thead>
            <tbody>
                {#each category.items as item}
                <tr>
                    <th>{item.title}</th>
                    <td>{@html marked.parse(item.description)}</td>
                    <td><a href="{item.url}">{item.url}</a></td>
                </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>
